import React, { useEffect, useState } from "react";

import "./index.scss";
import { useNavigate } from "react-router-dom";

import { IoEyeOutline } from "react-icons/io5";
import { FiCheckSquare } from "react-icons/fi";

import { BsBan } from "react-icons/bs";
function ContactResponsiveCards({
  blog,
  handleStatus,

  loadData,
}) {
  const [plus, setPlus] = useState(false);
  const navigate = useNavigate();

  return (
    <div id="AbonnementResponsiveCards">
      <div className="card my-4">
        <div className="d-flex ps-3 mt-3 align-items-center ">
          <span className="title me-3">Nom et Prénom:</span>
          <span>{blog?.nom}</span>
        </div>
        <hr />
        <div className="d-flex ps-3 align-items-center ">
          <span className="title me-3">Email: </span>
          <span>{blog?.email}</span>
        </div>{" "}
        <hr />
        <div className="d-flex ps-3 align-items-center ">
          <span className="title me-3">Téléphone:</span>
          <span>{blog?.tel ? blog?.tel : "Non renseigné"}</span>
        </div>
        <hr />
        <div className="d-flex ps-3 pb-3 align-items-center ">
          <span className="title me-3">Message:</span>
          <span>{blog?.message}</span>
        </div>
      </div>
    </div>
  );
}

export default ContactResponsiveCards;
